export default __webpack_public_path__ + "static/media/grupoqueretaro.f4ea1c45.jpg";